import { render, staticRenderFns } from "./change-path-dialog.vue?vue&type=template&id=f876bf86"
import script from "./change-path-dialog.vue?vue&type=script&lang=js"
export * from "./change-path-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports